module.exports = "/next-static/_next/static/images/full_duck-30e8f3bc50cbee3b8b76f66e9c64e73a.svg";